import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import NewsletterSettingsItems from './NewsletterSettingsItems';

const NewsLetterPreferencesModule = ({
  handlerSetComponents, components, id, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'NewsLetterSettingsModule',
    scopes: [],
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);

  const handlerSetScopes = (newScopes) => {
    const newState = {
      ...state,
      scopes: newScopes,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
      setIsLoading(false);
    }
  }, [components]);
  return (
    <div className="w-full pl-12 rounded-lg py-2 pr-4">
      <h2 className="w-full font-americaMonoRegular text-xs uppercase text-black my-2">
        Arrange the scopes to show on newsletter preferences page
      </h2>
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}`}>
          {(!isLoading || state.scopes.length) && <NewsletterSettingsItems handlerSetComponentsInParent={handlerSetScopes} components={state.scopes} lang={lang} />}
        </div>
      ))}
    </div>
  );
};

NewsLetterPreferencesModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  activeLanguage: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
};
NewsLetterPreferencesModule.defaultProps = {
  activeLanguage: 'en',
  languages: ['en', 'es', 'ca', 'pt'],
};

export default NewsLetterPreferencesModule;
